export default __webpack_public_path__ + "static/media/cessnaPic.1c64c340.jpeg";